import React, { useRef ,useEffect} from 'react'
import "./style.scss"
import { CForm, CSpinner } from '@coreui/react'
import CustomValuesHook from '../../../../Hooks/customValuesHook'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from 'react-router-dom';
import { postLogin } from '../../../../service/reactQueryServices/authService';
import { useMutation } from 'react-query';
import { LoginPayload } from '../../../../service/types/Auth/authApiRequestType';
import { getAllContactsRequestAction } from '../../../../service/actions/contactActions';
import { useDispatch } from 'react-redux';
import LoginParams from './loginParams';
import VerificationEmail from './verificationEmail';
// import { DSLogo } from '../../../../components/images_module';
import LoginAs from './loginAs';
import { DSLoading, DSLogo } from '../../../../components/images_module';
import ResetPassword from './resetPassword';
import { EmailOutLineSVG, EmailSVG, LoginSVG, PasswordOutLineSVG } from '../../../../components/IconSvg';
import { toast } from 'react-toastify';
import { setToken } from '../../../../components/helper';



const LoginPage = () => {
    const [states, setStates] = CustomValuesHook({ isCaptchaShow: false, displayResetPass: false })
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const { mutateAsync: login, isLoading } = useMutation("login", postLogin);

    const validation = Yup.object({
        username: Yup.string().email("ایمیل واردشده نامعتبر است").required("وارد کردن پست الکترونیک الزامی است."),
        password: Yup.string().required("وارد کردن کلمه عبور الزامی است."),



    })

    useEffect(()=>{

        return () => {
            if (localStorage.getItem("unAuthenticatedLink")) {
                localStorage.removeItem("unAuthenticatedLink")

            }
        };
    },[])

    const handleSubmit = async (values: LoginPayload) => {

        try {
            if (states.isCaptchaShow && !states.captcha) {
                toast.error("لطفا برای ورود تیک امنیتی را بزنید")
                return
            }
            const loginResponse = await login(values)

            if (loginResponse.access_token) {
                localStorage.setItem("token", loginResponse.access_token)
                localStorage.setItem("portalExtraInfo", JSON.stringify(loginResponse?.ExtraInfo))
                localStorage.setItem("dsTokenExpiration", loginResponse?.expires_in?.toString())
                // setToken(loginResponse.access_token)
                setTimeout(() => {
                    dispatch(getAllContactsRequestAction({
                        pageNumber: 1,
                        pageSize: 1000,
                        disablePaging: false,
                        whereConditionText: "",
                        sortText: "",
                    }))
                    const unAuthenticatedLink = localStorage.getItem("unAuthenticatedLink")
                    if (unAuthenticatedLink) {
                        localStorage.removeItem("unAuthenticatedLink")
                        navigate(unAuthenticatedLink)
                    } else {
                        navigate("/dashboard")

                    }
                }, 1000)
            }


        } catch (error: any) {

            if (states.isCaptchaShow) {
                recaptchaRef.current?.reset()
            }
            if (typeof error === "string") {
                toast.error(error)
            } else {
                toast.error("نام کاربری یا رمز عبور اشتباه است")

            }


            setStates({

                isCaptchaShow: error.Message.indexOf("invalid_grant_captcha_requrired") > -1 ||
                    error.Message.indexOf("captcha_required") > -1
            })

        }

    }


    const validate = () => { }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: { username: '', password: '', grant_type: 'password' },
        onSubmit: handleSubmit,
        validate,
    })

    console.log("isCaptchaShow", states.isCaptchaShow)

    if (states.displayResetPass) {
        return <ResetPassword backToLogin={() => setStates({ displayResetPass: false })} />
    }
    return (
        <div className='login-context'>
            <LoginParams />
            <LoginAs />
            <div className='logoHOlder d-flex justify-content-center'>
                <img alt='daftareshoma' src={DSLogo} />
            </div>
            <VerificationEmail />
            <div className='login-box' >
                <div className='container-login col-xs-2 col-sm-12 col-md-8 col-lg-3'>
                    <div>
                        <CForm className='frm' onSubmit={formik.handleSubmit} autoComplete="off">


                            <div className='d-flex flex-row justify-content-start'>
                                {/* <label className="registerQuestion">{t('Do_NOT_HAVE_ACCOUNT')}</label> */}
                                <label className='login-box-title'>
                                    {t('ENTER_TO_ACCOUNT')}
                                    <LoginSVG fill='#5d5d5d' />
                                </label>
                            </div>

                            <div className="form-group mt-3">
                                {/* <label htmlFor="exampleInputEmail1" className='d-flex flex-row justify-content-start lbl-frm' >{t('ENTER_YOUR_EMAIL')}</label> */}
                                <div className='input-container'>
                                    <input type='email' name="username" id="exampleInputEmail1"
                                        value={formik.values.username}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' placeholder={t('Email') || ""} />
                                    <span><EmailOutLineSVG fill='#5d5d5d' /></span>
                                </div>

                                {formik.errors.username && formik.touched.username && <label className='label-danger '>{formik.errors.username}</label>}
                            </div>

                            <div className="form-group mt-3">
                                {/* <label htmlFor="exampleInputPassword1" className='d-flex flex-row justify-content-start lbl-frm' >{t('ENTER_YOUR_PASSWORD')}</label> */}
                                <div className='input-container'>
                                    <input type='password' name="password" id="exampleInputPassword1"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' placeholder={t('Password') || ""} />
                                    <span><PasswordOutLineSVG fill='#5d5d5d' /></span>
                                </div>

                                {formik.errors.password && formik.touched.password && <label className='label-danger '>{formik.errors.password}</label>}
                            </div>

                            {states.isCaptchaShow && <div className="form-group d-flex flex-row justify-content-center captchaShow">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6LfAsqobAAAAAHeQggR84Aa_Yfmpmt-tMakai0KM"
                                    onChange={() => setStates({ captcha: recaptchaRef?.current?.getValue() })}
                                />
                            </div>}
                            {states.captchaMessage && <p>{states.captchaMessage}</p>}


                            <div className='d-flex flex-row justify-content-start forgetHolder'>
                                {/* <label className="registerQuestion">{t('FORGET_PASSWORD')}</label> */}
                            </div>

                            <button type="submit"
                                disabled={isLoading}
                                className={`btn d-flex align-items-center  justify-content-center ${states.isCaptchaShow ? 'frm-margin-captcha' : 'frm-margin'}  frm-btn col-xs-12 col-sm-12 col-md-12 col-lg-12`}>
                                {t('ENTER_TO_ACCOUNT')}
                                {isLoading && <CSpinner size='sm' color='light' className='mx-2' />}
                            </button>


                        </CForm>
                    </div>
                    <section className='d-flex flex-row justify-content-between links-containers'>

                        <Link to="/register" >{t('CREATE_ACCOUNT')}</Link>
                        <span onClick={() => setStates({ displayResetPass: true })} >{t('RESET_PASSWORD')}</span>

                    </section>

                </div>
            </div>


            <div className='d-flex flex-row justify-content-center footerTxt'>
                <span>
                    {t('FOOTER')}
                </span>
            </div>

        </div>
    )
}

export default LoginPage